import { AssetTypeFieldsService as OvermapAssetTypeFieldsService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class AssetTypeFieldsService extends OvermapAssetTypeFieldsService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
